export default {
    title: 'Moje narudžbine',
    surcharge: 'Doplata',
    delivery: 'Dostava',
    note: "Napomena",
    headers: {
        store: 'Prodavnica',
        orderNumber: 'Broj narudžbine',
        orderDate: 'Datum narudžbine',
        quantity: 'Količina',
        totalSum: 'Ukupna suma',
        status: 'Status'
    },
    buttons: {
        cancel: 'Otkaži',
        confirm: 'Potvrdi',
        remove: 'Ukloni',
        review: 'Ocijeni',
        askSeller: 'Pitaj prodavca',
        viewBill: 'Pogledaj račun'
    },
    filter: {
        allStatuses: 'Svi statusi',
        confirmed: 'Potvrđeno',
        delivered: 'Dostavljeno',
        inTransit: 'U tranzitu',
        packaging: 'Pakuje se',
        processed: 'Obrađuje se',
        canceled: 'Otkazano'
    },
    modal: {
        close: 'Zatvori',
        cancel: 'Otkaži',
        confirm: 'Potvrdi',
        review: 'Ocijeni'
    },
    cancelModal: {
        title: 'Otkaži narudžbinu',
        areYouSure: "Da li ste sigurni da želite da otkažete ovu narudžbinu? Jednom otkazana narudžbina se ne može obnoviti.",
        successMessage: 'Vaša narudžbina je uspješno otkazana.'
    },
    confirmModal: {
        title: 'Potvrda narudžbine',
        successMessage: 'Vaša narudžbina je uspješno potvrđena.'
    },
    reviewModal: {
        title: 'Ocijenite proizvode',
        rateProduct: 'Ocijenite proizvod',
        leaveComment: 'Ostavite komentar',
        optional: 'opciono',
        successMessage: 'Uspješno ste ocijenili proizvod.'
    },
    cart: {
        successMessage: 'Proizvodi su uspješno dodati u korpu.',
    }
}
